import {cleanItem, itemEditor} from "./expo-types/expo-types";
import {MailingClassLogic}     from "./mailing-class-logic";

export const MailingModules = ({item, templateOptions, getDefaultMailClass}) => [

    {
        name: "mailingClass1",
        load: (_, next) => MailingClassLogic({item, templateOptions, next}),
        expo: [cleanItem],
    },
    {
        name: "mailingClass2",
        load: ({method, mailingClass1, mailingListIds}, next) => method === "mailing" ? (
            mailingClass1.next({
                mailingListIds,
                getDefaultMailClass,
                next,
            })
        ) : (
            next(null)
        ),
        requires: ["method", "mailingClass1"],
        requiresOptional: ["mailingListIds"],
        expo: [itemEditor],
    },

];
